export default __webpack_public_path__ + "static/media/dashboard-2.a57e8c34.png";